import { Component } from '@angular/core';

@Component({
  selector: 'app-fixed-go-on',
  templateUrl: './fixed-go-on.component.html',
  styleUrl: './fixed-go-on.component.scss'
})
export class FixedGoOnComponent {

}
